import React, { useState, useEffect } from "react";
import { getDoc, doc, getFirestore } from "firebase/firestore";
import { Link } from "react-router-dom";
export default function ArticleDetail({ data, id, loading }) {
  const db = getFirestore();

  function formatTimestamp(seconds, nanoseconds) {
    const milliseconds = seconds * 1000 + nanoseconds / 1000000;
    const date = new Date(milliseconds);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function calcularTiempoDeLectura(caracteres) {
    const longitudMediaPalabra = 5; // Promedio de caracteres por palabra
    const velocidadLectura = 200; // Palabras por minuto

    const numeroPalabras = caracteres / longitudMediaPalabra;
    const tiempoLecturaMinutos = numeroPalabras / velocidadLectura;

    // Convertir el tiempo de minutos a un formato más legible
    const minutos = Math.floor(tiempoLecturaMinutos);
    const segundos = Math.floor((tiempoLecturaMinutos - minutos) * 60);

    return `${minutos} MINUTOS`;
  }

  const extractParagraphs = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const paragraphs = doc.querySelectorAll("p");
    return Array.from(paragraphs).map((p) => p.textContent);
  };

  const extractedParagraphs = data.body ? extractParagraphs(data.body) : "";

  const shareOnX = () => {
    const shareUrl = `https://x.com/intent/tweet?text=${encodeURIComponent(
      data.title + " en @Revista1986"
    )}&url=${encodeURIComponent(`https://revista1986.com.ar/article/${id}`)}`;
    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };

  const [relatedArticles, setRelatedArticles] = useState([]);
  const fetchArticleById = async () => {
    if (data.related && data.related.length > 0) {
      try {
        const relatedDocs = await Promise.all(
          data.related.map(async (relatedId) => {
            const docRef = doc(db, "articles", relatedId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              return { id: relatedId, ...docSnap.data() };
            } else {
              console.log(`No such document with ID: ${relatedId}`);
              return null;
            }
          })
        );

        // Filter out null values (in case some documents were not found)
        const validRelatedDocs = relatedDocs.filter((doc) => doc !== null);

        setRelatedArticles(validRelatedDocs);
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  useEffect(() => {
    fetchArticleById();
  }, [id, data.related]);

  return (
    <div className="article-detail-cont">
      <div className="article-detail-cover-cont">
        <img className="article-detail-cover" src={data.cover} alt="" />
        <img className="article-detail-cover-back" src={data.cover} alt="" />
        <div className="glow"></div>
      </div>

      <div className="article-detail-title-cont">
        <div className="article-details-cont">
          <p className="article-detail-author">
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/material-rounded/24/ffffff/writer-male.png"
              alt="writer-male"
            />{" "}
            {data.author}{" "}
          </p>
          <p className="article-detail-category">
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/ios-glyphs/30/ffffff/opened-folder.png"
              alt="opened-folder"
            />
            {data.category}{" "}
          </p>
          <p className="article-detail-date">
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/ios-filled/50/calendar--v1.png"
              alt="calendar--v1"
            />
            {data.date.seconds
              ? formatTimestamp(data.date.seconds, data.date.nanoseconds)
              : data.date}{" "}
          </p>

          <p className="article-detail-date">
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/ios-filled/50/reading.png"
              alt="lectura"
            />
            Lectura en{" "}
            {data.body
              ? calcularTiempoDeLectura(extractedParagraphs.join(" ").length)
              : ""}
          </p>
        </div>
      </div>
      <div className="article-detail-titleandsubtitlecont">
        <p className="article-detail-title"> {data.title} </p>
        <p className="article-detail-subtitle"> {data.subtitle} </p>
        <p className="article-detail-line"></p>
      </div>

      <p
        className="article-detail-content"
        dangerouslySetInnerHTML={{ __html: data.body }}
      ></p>

      <div className="article-detail-footer">
        <div className="article-details-cont">
          {data.tags ? (
            <>
              {data.tags.map((tag) => (
                <button className="article-detail-tag">{tag}</button>
              ))}
            </>
          ) : (
            <></>
          )}
          <button className="article-detail-category" onClick={shareOnX}>
            Compartir en{" "}
            <img
              width="14"
              height="14"
              src="https://img.icons8.com/ios-glyphs/30/ffffff/twitterx--v2.png"
              alt="twitterx--v1"
            />
          </button>
        </div>

        {/* <p className="article-detail-related-title"> Notas relacionadas</p> */}
        <div className="article-detail-related">
          <div className="article-detail-related-title">
            <img
              className="marginzero2"
              width="24"
              height="24"
              src="https://img.icons8.com/material-rounded/24/ffffff/reading--v1.png"
              alt="reading--v1"
            />
            <p className="marginzero2 ">NOTAS</p>
            <p className="marginzero2 ">RELACIONADAS</p>
          </div>

          {relatedArticles.length > 0 && (
            <>
              {relatedArticles.map((article) => (
                <a
                  href={`/article/${article.id}`}
                  key={article.id}
                  className="related-item-cont border-radius"
                >
                  <img className="top-item-img" src={article.cover} alt="" />
                  <div className="top-item-text-cont">
                    <div className="row100">
                      {article.author ? (
                        <p className="top-item-author">Por {article.author}</p>
                      ) : (
                        <></>
                      )}
                      <p className="top-item-category">{article.category}</p>
                    </div>

                    <p className="top-item-title"> {article.title} </p>
                    {/* <p className='top-item-subtitle'> {subtitle} </p> */}
                  </div>
                </a>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
